import { Component, OnInit } from '@angular/core';
import { DialogRef } from '@fundamental-ngx/core/dialog';
import { ResourceModel } from '../../../../core/models/resources/resource.model';
import { NotificationsService } from '../../../../service/services/misc/notifications/notifications.service';
import { Utils } from '../../../../core/helpers/Utils';
import { Observable, lastValueFrom } from 'rxjs';

@Component({
    selector: 'reconcile-failed-error-message-dialog',
    templateUrl: './reconcile-failed-error-message-dialog.component.html',
    styleUrls: ['./reconcile-failed-error-message-dialog.component.scss'],
    standalone: false
})
export class ReconcileFailedErrorMessageDialogComponent implements OnInit {
    resource: ResourceModel;
    type: string;
    title: string;
    generalErrorMsg: string;
    errorMsgMoreDetails: string;
    loading = false;
    showMoreDetails = false;
    viewDetailsTextVisible = true;

    constructor(
		public dialogRef: DialogRef
    ) {}

    ngOnInit(): void {
        let data = this.dialogRef.data;
        this.resource = data.resource;
        this.generalErrorMsg = "We were unable to reconcile the resource. Please try again and ensure you have the necessary permissions.";
        this.errorMsgMoreDetails = data.errorMsg;
    }

    viewErrorDetails() {
        this.viewDetailsTextVisible = false;
        this.showMoreDetails = true;
    }

    hideErrorDetails() {
        this.viewDetailsTextVisible = true;
        this.showMoreDetails = false;
    }

    onClose() {
        this.dialogRef.close();
    }

    validate() {
        return !this.loading;
    }
}
